<style lang="less">
@import "../assets/less/icon.less";
.wrapper{
    .tip{
        background:#d5c8f4;
        width:650px;
        margin:0 auto;
        padding:30px;
        line-height: 1.5;
        color:#fff;
        font-weight: 700;
        font-size: 28px;
        border-radius: 50px 50px 0 0;
        margin-top: 50px;
    }
    div.browser-list {
        padding:30px;
        background:#fafafa;
        margin:0 20px;
        border-radius: 0 0 30px 30px;
        div.bro-element {
            display: flex;
            justify-content: space-around;
            align-items: center;
            margin-top: 30px;
            padding-bottom:30px;
            border-bottom:1px solid #a585ef;
            &:last-child{
                border-bottom:none;
            }
            i.icon.icon-safari {
                width: 80px;
                height: 80px;                
                background:url("../../src/assets/images/download/safari.png") no-repeat;
                background-size:100% 100%;
            }
            i.icon.icon-chrome {
                width: 80px;
                height: 80px;                
                background:url("../../src/assets/images/download/chrome.png") no-repeat;
                background-size:100% 100%;
            }
            i.icon.icon-edge {
                width: 80px;
                height: 80px;                
                background:url("../../src/assets/images/download/edge.png") no-repeat;
                background-size:100% 100%;
            }
            i.icon.icon-firefox {
                width: 80px;
                height: 80px;                
                background:url("../../src/assets/images/download/firefox.png") no-repeat;
                background-size:100% 100%;
            }

            p.icon-text {
                width: 450px;
                font-size: 28px;
                line-height: 1.5;
                word-break: break-all;
                span {
                    color:#a585ef;
                }
            }            
        }
    }
}
</style>
<template>    
    <div class="wrapper">
        <div class="tip">
            Tip: Please select the browser you are currently using to view the add tutorial 
        </div>
        <div class="browser-list">
            <div class="bro-element" @click="jumpTo(0)">
                <i class="icon icon-safari"></i>
                <p class="icon-text">
                    Tutorial on how to add this app to desktop in <span>Safari</span> browser
                </p>
                <i class="icon icon-arrow-right"></i>
            </div>
            <div class="bro-element" @click="jumpTo(1)">
                <i class="icon icon-chrome"></i>
                <p class="icon-text">
                    Tutorial on how to add this app to desktop in <span>Chrome</span> browser
                </p>
                <i class="icon icon-arrow-right"></i>
            </div>
            <div class="bro-element" @click="jumpTo(2)">
                <i class="icon icon-edge"></i>
                <p class="icon-text">
                    Tutorial on how to add this app to desktop in <span>Edge</span> browser
                </p>
                <i class="icon icon-arrow-right"></i>
            </div>
            <div class="bro-element" @click="jumpTo(3)">
                <i class="icon icon-firefox"></i>
                <p class="icon-text">
                    Tutorial on how to add this app to desktop in <span>Firefox</span> browser
                </p>
                <i class="icon icon-arrow-right"></i>
            </div>
        </div> 
    </div>
</template>
<script>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
export default {
    setup () {        
        const router = useRouter()
        onMounted( ()=>{
            document.body.style.height = window.screen.height + 'px'                                    
        }) 
        const jumpTo = (ind) => {
            if(ind == 0) {
                router.push({
                    "path":"/download/safari"
                })
            } else if(ind == 1) {
                router.push({
                    "path":"/download/chrome"
                })
            } else if(ind == 2) {
                router.push({
                    "path":"/download/edge"
                })
            } else if(ind == 3) {
                router.push({
                    "path":"/download/firefox"
                })
            }
            return
        }
        return {
            jumpTo
        }
    }
}
</script>
